// export const API = "http://localhost:5000/api";
// Live Server Heroku IP
export const API = "https://fuelmanagement-gm1.herokuapp.com/api";
